import { oc } from '@orpc/contract';
import { ACCOUNT_STATUSES } from '@lsc/domain';
import { z } from 'zod';
export const resolveInput = z.object({
    /** The number as typed; the API parses it to E.164 and says `unparseable` when it cannot. */
    phone: z.string().trim().min(3).max(40),
});
const matchSource = z.enum(['phone_link', 'entity_link', 'account_cs_phone']);
export const phoneMatch = z.object({
    accountId: z.uuid(),
    label: z.string(),
    city: z.string().nullable().optional(),
    legalName: z.string().nullable(),
    legalEntityId: z.uuid().nullable(),
    processor: z.string(),
    mid: z.string().nullable(),
    status: z.enum(ACCOUNT_STATUSES),
    contactId: z.uuid().nullable(),
    contactName: z.string().nullable(),
    sources: z.array(matchSource),
});
export const entityGroup = z.object({
    legalEntityId: z.uuid().nullable(),
    legalName: z.string().nullable(),
    accounts: z.number().int(),
    open: z.number().int(),
});
export const draftHint = z.object({
    draftId: z.uuid(),
    companyName: z.string().nullable(),
    contactName: z.string().nullable(),
    source: z.string(),
    notes: z.string().nullable(),
});
/** Mirrors `CallerResolution` in `@lsc/domain`; the desk and the pop render these four shapes. */
export const callerResolution = z.discriminatedUnion('status', [
    z.object({ status: z.literal('unparseable'), raw: z.string() }),
    z.object({ status: z.literal('none'), e164: z.string(), draft: draftHint.nullable() }),
    z.object({ status: z.literal('one'), e164: z.string(), match: phoneMatch }),
    z.object({
        status: z.literal('many'),
        e164: z.string(),
        matches: z.array(phoneMatch),
        total: z.number().int(),
        truncated: z.boolean(),
        entities: z.array(entityGroup),
        crossEntity: z.boolean(),
        suggestedAccountId: z.uuid().nullable(),
    }),
]);
export const accountResolve = oc.route({ method: 'POST', path: '/accounts/resolve', summary: 'Who is on this number: one account, a chain, a recognised caller, or nobody' }).input(resolveInput).output(callerResolution);
//# sourceMappingURL=resolve.js.map